import { RightOutlined } from "@ant-design/icons";
import { SocialMediaInfluencerComp } from "@features/socialMediaInfluencer/SocialMediaInfluencerComp";
import { SocialMediaInfluencerRequest } from "@shared/lib/types/influencer";
import { Button } from "@shared/ui/Button";
import { Drawer } from "antd";
import React, { useEffect, useState } from "react";

interface Props {
  socialMediaInfluencerReq: SocialMediaInfluencerRequest;
  handleSuccess?: () => void;
  creatorInfo: {
    name?: string;
    image?: string;
    username?: string;
  };
  children?: React.ReactNode;
}
export function InfDetailsButtonV2({
  socialMediaInfluencerReq,
  creatorInfo,
  handleSuccess,
  children,
}: Props) {
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    if (!visible) {
      handleSuccess && handleSuccess();
    }
  }, [visible]);
  return (
    <>
      {children ? (
        <div onClick={(e) => {
          setVisible(true);
          e.stopPropagation();
          }} style={{ cursor: "pointer", display: "inline-block", width: "100%" }}>
          {children}
        </div>
      ) : (
        <Button
          type="text"
          icon={<RightOutlined />}
          onClick={() => setVisible(true)}
        />
      )}
      <Drawer
        title="Influencer Details"
        open={visible}
        width={1300}
        footer={null}
        destroyOnClose
        onClose={() => setVisible(false)}
      >
        {socialMediaInfluencerReq && (
          <SocialMediaInfluencerComp
            creatorInfo={creatorInfo}
            socialMediaInfluencerReq={socialMediaInfluencerReq}
          />
        )}
      </Drawer>
    </>
  );
}
